import router from './router'
//import axios from 'axios'
import http from '@/utils/http';
const _import = require('./router/_import_' + process.env.NODE_ENV) //获取组件的方法
import Layout from '@/views/layout'
import Container from '@/views/Container'
import {
	Message
} from "element-ui"; //Layout 是架构组件，不在后台返回，在文件里单独引入
// import index from '@/views/index'

var getRouter; //用来获取后台拿到的路由
// {
//       "path": "/",
//       "redirect": "/index",
//     },
let fakeRouter = {
	"router": [{
		"key": "1318468553060958210",
		"value": "1318468553060958210",
		"title": "首页",
		"isLeaf": true,
		"id": "1318468553060958210",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "首页",
		"url": "/",
		"levelNo": 1,
		"sortNo": 1,
		"delFlag": 0,
		"component": "index/index",
		"redirect": null,
		"componentName": "index",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/",
		"englishName": "1",
		"meta": {
			"title": "首页",
			"icon": ""
		},
		"children": null
	}, {
		"key": "1324633021214294018",
		"value": "1324633021214294018",
		"title": "院士阵容",
		"isLeaf": false,
		"id": "1324633021214294018",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "院士阵容",
		"url": "/Academician",
		"levelNo": 1,
		"sortNo": 1,
		"delFlag": 0,
		"component": "Layout",
		"redirect": null,
		"componentName": "left",
		"pid": null,
		"hasChild": null,
		"hidden": true,
		"path": "/Academician",
		"englishName": "Academician academicianList",
		"meta": {
			"title": "院士阵容",
			"icon": ""
		},
		"children": [{
			"key": "1324634199448813570",
			"value": "1324634199448813570",
			"title": "院士阵容_",
			"isLeaf": true,
			"id": "1324634199448813570",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1324633021214294018",
			"name": "院士阵容_",
			"url": "academicianList/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "category/oneColumns",
			"redirect": null,
			"componentName": "1",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "academicianList/:id",
			"englishName": "Academician academicianList",
			"meta": {
				"title": "院士阵容_",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318469148568240130",
		"value": "1318469148568240130",
		"title": "关于我们",
		"isLeaf": false,
		"id": "1318469148568240130",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "关于我们",
		"url": "/aboutUs",
		"levelNo": 1,
		"sortNo": 2,
		"delFlag": 0,
		"component": "Layout",
		"redirect": "",
		"componentName": "aboutUs",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/aboutUs",
		"englishName": "About Us",
		"meta": {
			"title": "关于我们",
			"icon": ""
		},
		"children": [{
			"key": "1318471030107848706",
			"value": "1318471030107848706",
			"title": "企业简介",
			"isLeaf": true,
			"id": "1318471030107848706",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469148568240130",
			"name": "企业简介",
			"url": "company",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "article/page",
			"redirect": "/page/index/1323553333190995970",
			"componentName": "Company Profile",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "company",
			"englishName": "Company Profile",
			"meta": {
				"title": "企业简介",
				"icon": ""
			},
			"children": null
		}, {
			"key": "1318471148458524674",
			"value": "1318471148458524674",
			"title": "企业文化",
			"isLeaf": true,
			"id": "1318471148458524674",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469148568240130",
			"name": "企业文化",
			"url": "index/:id",
			"levelNo": 2,
			"sortNo": 2,
			"delFlag": 0,
			"component": "article/index",
			"redirect": "",
			"componentName": "qiyewenhua",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "index/:id",
			"englishName": null,
			"meta": {
				"title": "企业文化",
				"icon": ""
			},
			"children": null
		}, {
			"key": "1318471275915034625",
			"value": "1318471275915034625",
			"title": "大事记",
			"isLeaf": true,
			"id": "1318471275915034625",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469148568240130",
			"name": "大事记",
			"url": "memorabilia/:id",
			"levelNo": 2,
			"sortNo": 3,
			"delFlag": 0,
			"component": "article/memorabilia",
			"redirect": "",
			"componentName": "dashiji",
			"pid": null,
			"hasChild": null,
			"hidden": true,
			"path": "memorabilia/:id",
			"englishName": "memorabilia",
			"meta": {
				"title": "大事记",
				"icon": ""
			},
			"children": null
		}, {
			"key": "1318471380818771969",
			"value": "1318471380818771969",
			"title": "联系我们",
			"isLeaf": true,
			"id": "1318471380818771969",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469148568240130",
			"name": "联系我们",
			"url": "contectUs",
			"levelNo": 2,
			"sortNo": 4,
			"delFlag": 0,
			"component": "article/contectUs",
			"redirect": "",
			"componentName": "contactus",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "contectUs",
			"englishName": "contect Us",
			"meta": {
				"title": "联系我们",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318469299890339842",
		"value": "1318469299890339842",
		"title": "新闻中心",
		"isLeaf": false,
		"id": "1318469299890339842",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "新闻中心",
		"url": "/news",
		"levelNo": 1,
		"sortNo": 3,
		"delFlag": 0,
		"component": "Layout",
		"redirect": "",
		"componentName": "newscenter",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/news",
		"englishName": "News Center",
		"meta": {
			"title": "新闻中心",
			"icon": ""
		},
		"children": [{
			"key": "1322081020817862658",
			"value": "1322081020817862658",
			"title": "新闻中心_",
			"isLeaf": true,
			"id": "1322081020817862658",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469299890339842",
			"name": "新闻中心_",
			"url": "list/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "category/oneColumns",
			"redirect": "",
			"componentName": "news",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "list/:id",
			"englishName": "News Center",
			"meta": {
				"title": "新闻中心_",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318469982412652545",
		"value": "1318469982412652545",
		"title": "解决方案",
		"isLeaf": false,
		"id": "1318469982412652545",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "解决方案",
		"url": "/Solution",
		"levelNo": 1,
		"sortNo": 6,
		"delFlag": 0,
		"component": "Layout",
		"redirect": null,
		"componentName": "Solution",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/Solution",
		"englishName": null,
		"meta": {
			"title": "解决方案",
			"icon": ""
		},
		"children": [{
			"key": "1323147905475014658",
			"value": "1323147905475014658",
			"title": "解决方案_",
			"isLeaf": true,
			"id": "1323147905475014658",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469982412652545",
			"name": "解决方案_",
			"url": "Solution/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "oneStopSolution/oneStop",
			// "redirect": "/news/list/:id",
			"componentName": "Solution",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "Solution/:id",
			"englishName": "Solution",
			"meta": {
				"title": "解决方案_",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318469501195960322",
		"value": "1318469501195960322",
		"title": "科研专项",
		"isLeaf": false,
		"id": "1318469501195960322",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "科研专项",
		"url": "/Special",
		"levelNo": 1,
		"sortNo": 4,
		"delFlag": 0,
		"component": "Layout",
		"redirect": null,
		"componentName": "kyzx",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/Special",
		"englishName": "Special Scientific Research",
		"meta": {
			"title": "科研专项",
			"icon": ""
		},
		"children": [{
			"key": "1322120997291323393",
			"value": "1322120997291323393",
			"title": "科研专项_",
			"isLeaf": true,
			"id": "1322120997291323393",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469501195960322",
			"name": "科研专项_",
			"url": "twoColumns/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "category/twoColumns",
			"redirect": null,
			"componentName": "Special Scientific Research",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "twoColumns/:id",
			"englishName": "Special Scientific Research",
			"meta": {
				"title": "科研专项_",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318469692493971457",
		"value": "1318469692493971457",
		"title": "业务领域",
		"isLeaf": false,
		"id": "1318469692493971457",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "业务领域",
		"url": "/businessarea",
		"levelNo": 1,
		"sortNo": 5,
		"delFlag": 0,
		"component": "Layout",
		"redirect": null,
		"componentName": "businessarea",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/businessarea",
		"englishName": null,
		"meta": {
			"title": "业务领域",
			"icon": ""
		},
		"children": [{
			"key": "1318471542563717121",
			"value": "1318471542563717121",
			"title": "智慧水环境",
			"isLeaf": true,
			"id": "1318471542563717121",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469692493971457",
			"name": "智慧水环境",
			"url": "index/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "category/oneColumns",
			"redirect": "/news/list/:id",
			"componentName": "Smart Water Environment",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "index/:id",
			"englishName": null,
			"meta": {
				"title": "智慧水环境",
				"icon": ""
			},
			"children": null
		}, 
		{
			"key": "1318471651045195778",
			"value": "1318471651045195778",
			"title": "智慧水务",
			"isLeaf": true,
			"id": "1318471651045195778",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469692493971457",
			"name": "智慧水务",
			"url": "SmartWater/:id",
			"levelNo": 2,
			"sortNo": 2,
			"delFlag": 0,
			"component": "category/oneColumns",
			"redirect": "/news/list/:id",
			"componentName": "Smart Water",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "SmartWater/:id",
			"englishName": null,
			"meta": {
				"title": "智慧水务",
				"icon": ""
			},
			"children": null
		}, 
		{
			"key": "1318471766027845634",
			"value": "1318471766027845634",
			"title": "智慧水利",
			"isLeaf": true,
			"id": "1318471766027845634",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469692493971457",
			"name": "智慧水利",
			"url": "waterConservancy/:id",
			"levelNo": 2,
			"sortNo": 3,
			"delFlag": 0,
			"component": "category/oneColumns",
			"redirect": "/news/list/:id",
			"componentName": "Smart water conservancy",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "waterConservancy/:id",
			"englishName": null,
			"meta": {
				"title": "智慧水利",
				"icon": ""
			},
			"children": null
		}, {
			"key": "1318471860437434369",
			"value": "1318471860437434369",
			"title": "智慧城市",
			"isLeaf": true,
			"id": "1318471860437434369",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469692493971457",
			"name": "智慧城市",
			"url": "SmartCity/:id",
			"levelNo": 2,
			"sortNo": 4,
			"delFlag": 0,
			"component": "category/oneColumns",
			"redirect": "/news/list/:id",
			"componentName": "Smart City",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "SmartCity/:id",
			"englishName": null,
			"meta": {
				"title": "智慧城市",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318469982412652545",
		"value": "1318469982412652545",
		"title": "科技矩阵",
		"isLeaf": false,
		"id": "1318469982412652545",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "科技矩阵",
		"url": "/matrix",
		"levelNo": 1,
		"sortNo": 6,
		"delFlag": 0,
		"component": "Layout",
		"redirect": null,
		"componentName": "matrix",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/matrix",
		"englishName": "Matrix of science and technology",
		"meta": {
			"title": "科技矩阵",
			"icon": ""
		},
		"children": [{
			"key": "1323147905475014658",
			"value": "1323147905475014658",
			"title": "科技矩阵_",
			"isLeaf": true,
			"id": "1323147905475014658",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318469982412652545",
			"name": "科技矩阵_",
			"url": "index/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "matrix/index",
			// "redirect": "/news/list/:id",
			"componentName": "matrix",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "index/:id",
			"englishName": "index",
			"meta": {
				"title": "科技矩阵_",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1318470166672621570",
		"value": "1318470166672621570",
		"title": "战略布局",
		"isLeaf": true,
		"id": "1318470166672621570",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "战略布局",
		"url": "disabled",
		"levelNo": 1,
		"sortNo": 7,
		"delFlag": 0,
		"component": "Layout",
		"redirect": "",
		"componentName": "strategiclayout",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "disabled",
		"englishName": null,
		"meta": {
			"title": "战略布局",
			"icon": ""
		},
		"children": null
	}, {
		"key": "1318470297828507649",
		"value": "1318470297828507649",
		"title": "加入我们",
		"isLeaf": false,
		"id": "1318470297828507649",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "加入我们",
		"url": "/joinus",
		"levelNo": 1,
		"sortNo": 8,
		"delFlag": 0,
		"component": "emptyFrame/index",
		"redirect": null,
		"componentName": "joinus",
		"pid": null,
		"hasChild": null,
		"hidden": false,
		"path": "/joinus",
		"englishName": null,
		"meta": {
			"title": "加入我们",
			"icon": ""
		},
		"children": [{
			"key": "1318471959074881538",
			"value": "1318471959074881538",
			"title": "诚聘英才",
			"isLeaf": false,
			"id": "1318471959074881538",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318470297828507649",
			"name": "诚聘英才",
			"url": "recruit",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "Layout",
			"redirect": "/joinus/recruit/list/:id",
			"componentName": "Join Us",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "recruit",
			"englishName": null,
			"meta": {
				"title": "诚聘英才",
				"icon": ""
			},
			"children": [{
				"key": "1321284075597844482",
				"value": "1321284075597844482",
				"title": "技术类",
				"isLeaf": true,
				"id": "1321284075597844482",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "技术类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "技术类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284498924752898",
				"value": "1321284498924752898",
				"title": "商务合作类",
				"isLeaf": true,
				"id": "1321284498924752898",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "商务合作类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "商务合作类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284560924954626",
				"value": "1321284560924954626",
				"title": "市场类",
				"isLeaf": true,
				"id": "1321284560924954626",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "市场类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "市场类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284644337078274",
				"value": "1321284644337078274",
				"title": "销售类",
				"isLeaf": true,
				"id": "1321284644337078274",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "销售类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "销售类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284767335043073",
				"value": "1321284767335043073",
				"title": "产品咨询类",
				"isLeaf": true,
				"id": "1321284767335043073",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "产品咨询类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "/js",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "产品咨询类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284831197515777",
				"value": "1321284831197515777",
				"title": "职能类",
				"isLeaf": true,
				"id": "1321284831197515777",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "职能类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "职能类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284978715381761",
				"value": "1321284978715381761",
				"title": "招采管理类",
				"isLeaf": true,
				"id": "1321284978715381761",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "招采管理类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "招采管理类",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1323465576533270529",
				"value": "1323465576533270529",
				"title": "招聘文章（隐藏）",
				"isLeaf": true,
				"id": "1323465576533270529",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "招聘文章（隐藏）",
				"url": "article/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "joinUs/article",
				"redirect": null,
				"componentName": "joinUs",
				"pid": null,
				"hasChild": null,
				"hidden": true,
				"path": "article/:id",
				"englishName": "1",
				"meta": {
					"title": "招聘文章（隐藏）",
					"icon": ""
				},
				"children": null
			}, {
				"key": "1321284214651604993",
				"value": "1321284214651604993",
				"title": "项目实施类",
				"isLeaf": true,
				"id": "1321284214651604993",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318471959074881538",
				"name": "项目实施类",
				"url": "list/:id",
				"levelNo": 2,
				"sortNo": 2,
				"delFlag": 0,
				"component": "joinUs/index",
				"redirect": "",
				"componentName": "Join Us",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "list/:id",
				"englishName": null,
				"meta": {
					"title": "项目实施类",
					"icon": ""
				},
				"children": null
			}]
		}, {
			"key": "1318472067262758914",
			"value": "1318472067262758914",
			"title": "人才发展",
			"isLeaf": false,
			"id": "1318472067262758914",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1318470297828507649",
			"name": "人才发展",
			"url": "talent",
			"levelNo": 2,
			"sortNo": 2,
			"delFlag": 0,
			"component": "Layout",
			"redirect": "/joinus/talent/index/1323595208465231874",
			"componentName": "Talent Development",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "talent",
			"englishName": "Talent Development",
			"meta": {
				"title": "人才发展",
				"icon": ""
			},
			"children": [{
				"key": "1323245738246299649",
				"value": "1323245738246299649",
				"title": "人才发展_",
				"isLeaf": true,
				"id": "1323245738246299649",
				"createBy": null,
				"createTime": null,
				"updateBy": null,
				"updateTime": null,
				"sysOrgCode": null,
				"parentId": "1318472067262758914",
				"name": "人才发展_",
				"url": "index/:id",
				"levelNo": 2,
				"sortNo": 1,
				"delFlag": 0,
				"component": "article/talent",
				"redirect": "",
				"componentName": "Talent Development",
				"pid": null,
				"hasChild": null,
				"hidden": false,
				"path": "index/:id",
				"englishName": "Talent Development",
				"meta": {
					"title": "人才发展_",
					"icon": ""
				},
				"children": null
			}]
		}]
	}, {
		"key": "1321280454630035458",
		"value": "1321280454630035458",
		"title": "权威领航",
		"isLeaf": false,
		"id": "1321280454630035458",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "权威领航",
		"url": "/qw",
		"levelNo": 1,
		"sortNo": 9,
		"delFlag": 0,
		"component": "Layout",
		"redirect": "",
		"componentName": "home",
		"pid": null,
		"hasChild": null,
		"hidden": true,
		"path": "/qw",
		"englishName": "Authoritative Navigation",
		"meta": {
			"title": "权威领航",
			"icon": ""
		},
		"children": [{
			"key": "1323831165223346177",
			"value": "1323831165223346177",
			"title": "权威领航_",
			"isLeaf": true,
			"id": "1323831165223346177",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1321280454630035458",
			"name": "权威领航_",
			"url": "twoColumns/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "category/twoColumns",
			"redirect": null,
			"componentName": "1",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "twoColumns/:id",
			"englishName": "Authoritative Navigation",
			"meta": {
				"title": "权威领航_",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1323575707929587714",
		"value": "1323575707929587714",
		"title": "文章页模板_",
		"isLeaf": false,
		"id": "1323575707929587714",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "文章页模板_",
		"url": "/category",
		"levelNo": 1,
		"sortNo": 21,
		"delFlag": 0,
		"component": "Layout",
		"redirect": "",
		"componentName": "1",
		"pid": null,
		"hasChild": null,
		"hidden": true,
		"path": "/category",
		"englishName": "1",
		"meta": {
			"title": "文章页模板_",
			"icon": ""
		},
		"children": [{
			"key": "1323575957478092802",
			"value": "1323575957478092802",
			"title": "文章页模板_ _",
			"isLeaf": true,
			"id": "1323575957478092802",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1323575707929587714",
			"name": "文章页模板_ _",
			"url": "article/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "article/index",
			"redirect": null,
			"componentName": "1",
			"pid": null,
			"hasChild": null,
			"hidden": true,
			"path": "article/:id",
			"englishName": "1",
			"meta": {
				"title": "文章页模板_ _",
				"icon": ""
			},
			"children": null
		}]
	}, {
		"key": "1323827179980234754",
		"value": "1323827179980234754",
		"title": "单页模板_",
		"isLeaf": false,
		"id": "1323827179980234754",
		"createBy": null,
		"createTime": null,
		"updateBy": null,
		"updateTime": null,
		"sysOrgCode": null,
		"parentId": null,
		"name": "单页模板_",
		"url": "/page",
		"levelNo": 1,
		"sortNo": 51,
		"delFlag": 0,
		"component": "Layout",
		"redirect": null,
		"componentName": "1",
		"pid": null,
		"hasChild": null,
		"hidden": true,
		"path": "/page",
		"englishName": "1",
		"meta": {
			"title": "单页模板_",
			"icon": ""
		},
		"children": [{
			"key": "1323827728062521346",
			"value": "1323827728062521346",
			"title": "单页模板_ -",
			"isLeaf": true,
			"id": "1323827728062521346",
			"createBy": null,
			"createTime": null,
			"updateBy": null,
			"updateTime": null,
			"sysOrgCode": null,
			"parentId": "1323827179980234754",
			"name": "单页模板_ -",
			"url": "index/:id",
			"levelNo": 2,
			"sortNo": 1,
			"delFlag": 0,
			"component": "article/page",
			"redirect": null,
			"componentName": "1",
			"pid": null,
			"hasChild": null,
			"hidden": false,
			"path": "index/:id",
			"englishName": "1",
			"meta": {
				"title": "单页模板_ -",
				"icon": ""
			},
			"children": null
		}]
	}],
}

// 假装fakeRouter是通过后台接口请求回来的数据
router.beforeEach((to, from, next) => {

	if (!getRouter) { //不加这个判断，路由会陷入死循环
		//静态路由
		// getRouter = fakeRouter.router //假装模拟后台请求得到的路由数据
		// saveObjArr('router', getRouter) //存储路由到localStorage
		// routerGo(to, next) //执行路由跳转方法

		// console.log("http.getRouter");
		// 动态路由
		http.get('/website/api/queryTreeList', ).then((res) => {
			getRouter = res.data.result //.slice(0,9)
			 // console.log("http",getRouter);
			saveObjArr('router', getRouter) //存储路由到localStorage
			routerGo(to, next) //执行路由跳转方法

		}).catch((err) => {
			console.log("router-err:", err);
			// Message.error(err.message)
		});

		// ----------------
		// if (!getObjArr('router')) {
		// easy-mock官网经常挂掉，所以就不请求了,你们可以替换成自己公司的接口去请求,把下方的axios请求打开即可
		// axios.get('https://www.easy-mock.com/mock/5a5da330d9b48c260cb42ca8/example/antrouter').then(res => {
		// getRouter = res.data.result
		// console.log(getRouter);
		// saveObjArr('router', getRouter) //存储路由到localStorage
		// routerGo(to, next) //执行路由跳转方法
		// })
		// } else { //从localStorage拿到了路由
		//   getRouter = getObjArr('router') //拿到路由
		//   console.log(getRouter)
		//   routerGo(to, next)
		// }
	} else {
		next()
	}

})


function routerGo(to, next) {
	getRouter = filterAsyncRouter(getRouter) //过滤路由
	// console.log("filtergetRouter", getRouter);
	router.addRoutes(getRouter) //动态添加路由
	global.antRouter = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
	next({ ...to,
		replace: true
	})
}

function saveObjArr(name, data) { //localStorage 存储数组对象的方法
	localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
	return JSON.parse(window.localStorage.getItem(name));

}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
	const accessedRouters = asyncRouterMap.filter(route => {
		if (route.component) {
			if (route.component === 'Layout') { //Layout组件特殊处理
				route.component = Layout
			}else if(route.component === 'Container'){
        route.component = Container
      } else {
			  if(route.component==='1'){  /*注:后端返回的1.vue文件暂时注释掉*/
			    return
        }
				route.component = _import(route.component)
			}
		}
		if (route.children && route.children.length) {
			route.children = filterAsyncRouter(route.children)
		}
		return true
	})

	return accessedRouters
}



// WEBPACK FOOTER //
// ./src/promission.js